import { FC } from "react";

type TrustBadgeProps = {
  reviewUrl?: string;
  src?: string;
  alt?: string;
  title?: string;
  width: number;
  height: number;
};

/**
 * Renders a third-party review/award badge.
 */
export const TrustBadge: FC<TrustBadgeProps> = ({
  reviewUrl,
  src,
  alt,
  title,
  width,
  height,
}) => (
  <a href={reviewUrl} target="_blank" rel="noopener noreferrer" title={title}>
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      style={{ maxWidth: width ? `${width}px` : undefined }}
      className="h-auto w-full"
    />
  </a>
);
